<template>
    <div>
        <v-row justify="center">
            <v-dialog v-model="message.modal" persistent max-width="380">
                <v-card class="text-center">
                    <v-card-title class="d-flex justify-center pt-4 ">
                        {{message.text}}
                    </v-card-title>
                    <v-btn color="info" small class="mb-4 mt-4" text href="/squaretest">Continue</v-btn>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: ['message'],
        data(){
            return{
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>